import { adminEventRuntimeApiSdk } from '@hds/admin-client-pinia-vue-sdk'
import { saleIndexStore } from '@hds/auto-auction-com-client-sdk'
import { computed, ref, unref } from 'vue'

import { groupLiveSales, unwrapList } from '@/lib/liveSales.js'

/**
 * The Live Sales page's data: a house's running sales, each with its lanes.
 *
 * Two reads, joined in `groupLiveSales`: vibe-server's sales (the client SDK's
 * store, loaded once per session) and the runtime's event activities (the
 * clerk's runtime client, already pointed at the runtime by
 * `configureBackends`). Read when the view asks — on mount and on Refresh; a
 * proof of concept does not poll.
 *
 * @param {Object} options
 * @param {import('vue').Ref<string>} options.houseCode The house to show; empty shows every house.
 */
export function useLiveSales({ houseCode }) {
    const saleIndex = saleIndexStore()
    const activities = ref([])
    const loading = ref(false)
    const failure = ref(null)

    async function refresh() {
        loading.value = true
        failure.value = null
        try {
            await saleIndex.ensureLoaded()
            activities.value = unwrapList(await adminEventRuntimeApiSdk.getEventActivities())
        } catch (error) {
            failure.value = error
        } finally {
            loading.value = false
        }
    }

    const sales = computed(() =>
        groupLiveSales({ sales: saleIndex.sales, activities: activities.value, houseCode: unref(houseCode) })
    )


    return { sales, loading, failure, refresh }
}
